import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Flex } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { serialize } from 'object-to-formdata';
import HeaderNavigation from 'components/HeaderNavigation';
import { FORM_MAX_WIDTH } from 'utils/constants';
import FooterButtons, { FOOTER_HEIGHT } from 'components/FooterButtons';
import FormBody from 'pages/Venues/Form/components/FormBody';
import { BODY_SCHEMA, DEFAULT_VALUES } from 'pages/Venues/Form/constants';
import ROUTES from 'app/routes';
import { API, APIRoutes } from 'api';
import { setFormErrors } from 'utils/api';
import { SERIALIZER_OPTIONS } from 'app/constants';
import { convertKeysToSnakeCase } from 'utils/helpers';
import ComponentPreview from 'components/PreviewWrapper';
import { prepareSchedulesAttributes } from 'components/Schedule/constants';
import FormWrapper from 'components/FormWrapper';

function VenueCreate() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const methods = useForm<Venue>({
    mode: 'onChange',
    resolver: yupResolver(BODY_SCHEMA),
    defaultValues: DEFAULT_VALUES,
  });

  const { handleSubmit, setError } = methods;

  const { mutate: createVenue, isLoading } = useMutation({
    mutationFn: (data: Venue) => {
      const snakePayload = convertKeysToSnakeCase(prepareSchedulesAttributes(data));
      const formData = serialize(snakePayload, SERIALIZER_OPTIONS, new FormData(), 'venue');
      return API.post(APIRoutes.venues.index(), formData);
    },
    mutationKey: 'venuesMutation',
    onSuccess: () => {
      toast.success('Obiekt został pomyślnie utworzony!');
      navigate(ROUTES.venues.base);
      void queryClient.invalidateQueries('venues');
    },
    onError: (error) => {
      setFormErrors(setError, error);
      toast.error('Wystąpił problem podczas tworzenia obiektu');
    },
  });

  const onSubmit = handleSubmit((data: Venue) => createVenue(data));

  return (
    <Box>
      <HeaderNavigation
        baseCrumb={{
          label: 'Obiekty',
          to: ROUTES.venues.base,
        }}
        crumbs={[{ to: '', label: 'Dodaj obiekt' }]}
      />
      <FormWrapper {...methods}>
        <Flex gap={4} mb={4} alignItems="flex-start" pb={FOOTER_HEIGHT}>
          <Box w="100%" as="form" id="venue-creator" onSubmit={onSubmit} maxW={FORM_MAX_WIDTH}>
            <FormBody isLoading={isLoading} />
          </Box>
          <ComponentPreview kind="venue" />
        </Flex>
      </FormWrapper>
      <FooterButtons isLoading={isLoading} isCreate formId="venue-creator" onCancel={() => navigate(-2)} />
    </Box>
  );
}

export default VenueCreate;
